// extracted by mini-css-extract-plugin
var _1 = "FxdNc";
var _2 = "sutbX";
var _3 = "BmUXi";
export { _1 as "base", _2 as "theme-dark", _3 as "theme-light" }
